import { ReactComponent as ConsumerGoodsSVG } from '../../../assets/images/icons/product_icons/product_recall_cgcp_icon.svg';

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ProductRecallCGCPIcon = (props: any) => {
    return (
        <SvgIcon {...props} component={ConsumerGoodsSVG} inheritViewBox />
        // <SvgIcon {...props}>
        //     <ConsumerGoodsSVG />
        // </SvgIcon>
    );
};

export default ProductRecallCGCPIcon;